import React from 'react'
import {
  Box,
  Paper,
} from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import ChronoImage from '@/layouts/core/components/ChronoImage'
import { ItemPanelProps } from '@/layouts/core/types/core'

const useStyles = makeStyles((theme: Theme) => ({
  cardContainer: {
    display: 'flex',
    flexDirection: 'row',
    [theme?.breakpoints?.down('sm')]: {
      flexDirection: 'column'
    },
  },
  imageContainer: {
    display: 'flex',
    flexDirection: 'row',
    [theme?.breakpoints?.down('sm')]: {
      flexDirection: 'column'
    },
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    [theme?.breakpoints?.down('sm')]: {
      marginTop: 20
    },
    [theme?.breakpoints?.up('sm')]: {
      marginLeft: 30
    },
  },
}))

/**
 * Component used to render card/panel for displaying a Store item
 *
 * @param props
 * @constructor
 */
const ChronoCard = (props: ItemPanelProps) => {
  const { paper, image, subImage = null, content, controls } = props
  const classes = useStyles()

  return (
    <Paper
      data-cy={props['data-cy']}
      className={props.className}
      elevation={paper?.elevation || 0}
      sx={{
        backgroundColor: paper?.backgroundColor,
        marginBottom: 2
      }}>
      <Box 
        className={classes.cardContainer} 
        padding={props.mini ? undefined : 2}
        justifyContent={'space-between'}>

        <Box 
          flexGrow={8} 
          className={classes.imageContainer}
          justifyContent={'start'}>

          <Box
            flexGrow={0}
            display={'flex'}
            flexDirection={'column'}
            position={'relative'}
            alignItems={'center'}>

            <ChronoImage {...image} />

            {subImage &&
              subImage
            }

          </Box>

          <Box 
            flexGrow={1}
            className={classes.contentContainer}
            flexBasis={'content'}>
            
            {content}
            
          </Box>
        </Box>

        {controls &&
          <Box flexGrow={4} minWidth={250}>
            {controls}
          </Box>
        }

      </Box>

    </Paper>
  )
}

export default ChronoCard